<template lang="html">
  <div class="animalform">
    <v-row justify=center>
      <v-col cols="12" sm="8" md="6">
        <v-dialog
           v-model="formerrors"
           max-width=500
         >
           <v-card>
             <v-card-title class="headline">Hiányzó/rossz adatok.</v-card-title>

             <v-card-text>
               Biztosan minden adatot szükséges adatot jól adott meg?<br/>
               Az azonosító egyedi kell, hogy legyen!<br/>
             </v-card-text>

             <v-card-actions>
               <div class="flex-grow-1"></div>

               <v-btn
                 color="green darken-1"
                 text
                 @click="formerrors = false"
               >
                 Rendben
               </v-btn>
             </v-card-actions>
           </v-card>
         </v-dialog>
        <span v-if="adminmethod==='new' && allAnimals.length>9" class="demoflashing red--text animated flash infinite">DEMO verzió. Új védenc hozzáadása előtt törölni kell!!</span>
        <h3 v-if="adminmethod==='new'">Új védenc hozzáadása</h3>
        <h3 v-if="adminmethod==='update'">Védenc módosítása : {{animal.name}} -- {{animal.shelterID}} </h3>
        <v-form ref="form" autocomplete="off">
           <v-text-field v-if="adminmethod==='new'"
              v-model="formanimal.shelterID"
              label="Egyedi azonosító, később nem változtatható meg!"
           ></v-text-field>

           <v-text-field
             v-model="formanimal.name"
             label="Neve"
             :rules="[rules.required,]"
           ></v-text-field>

           <v-combobox
             v-model="formanimal.species"
            :items="speciesItems"
             label="Faj"
             :rules="[rules.required,]"
           ></v-combobox>

           <v-combobox
              v-model="formanimal.gender"
              :items="genderItems"
              label="Ivara"
              :rules="[rules.required,]"
            ></v-combobox>

           <v-text-field
             v-model="formanimal.age"
             label="Kora"
             :rules="[rules.required,]"
           ></v-text-field>

           <v-text-field
             v-model="formanimal.breed"
             label="Fajtája"
           ></v-text-field>


            <v-text-field
              v-model="formanimal.size"
              label="Mérete, súlya"
            ></v-text-field>

            <v-dialog
              ref="dialog"
              v-model="datepicker1"
              :return-value.sync="formanimal.date_of_arrival"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="formanimal.date_of_arrival"
                  label="Védenc bekerülése"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="formanimal.date_of_arrival" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="brown" @click="datepicker1 = false">Mégsem</v-btn>
                <v-btn text color="brown" @click="$refs.dialog.save(formanimal.date_of_arrival)">OK</v-btn>
              </v-date-picker>
            </v-dialog>

           <v-combobox
             v-model="formanimal.colorcode"
             :items="colorCodeItems"
             label="Védenc színkódja"
              :hint="colorcodelistinfo"
                persistent-hint
           ></v-combobox>

           <v-checkbox
             v-model="formanimal.puppy"
             label="Kölyök?"
             color="#4f2523"

           ></v-checkbox>

           <v-checkbox
              v-model="formanimal.adoptable"
              label="Örökbeadható?"
              color="#4f2523"
           ></v-checkbox>

           <v-dialog
             ref="dialog2"
             v-model="datepicker2"
             :return-value.sync="formanimal.date_of_adoption"
             persistent
             width="290px"
           >
             <template v-slot:activator="{ on }">
               <v-text-field
                 v-model="formanimal.date_of_adoption"
                 label="Örökbefogadás időpontja"
                 v-on="on"
                 clearable
               ></v-text-field>
             </template>
             <v-date-picker v-model="formanimal.date_of_adoption" scrollable>
               <v-spacer></v-spacer>
               <v-btn text color="brown" @click="datepicker2 = false">Mégsem</v-btn>
               <v-btn text color="brown" @click="$refs.dialog2.save(formanimal.date_of_adoption)">OK</v-btn>
             </v-date-picker>
           </v-dialog>


           <v-text-field
             v-model="formanimal.sociallink"
             label="Közösségi oldal linkje"
           ></v-text-field>

           <v-text-field
             v-model="formanimal.documentlink"
             label="Dokumentumok linkje"
           ></v-text-field>

           <v-textarea
              background-color="transparent"
             solo
             v-model="formanimal.other"
             label="Egyéb megjegyzés"
           ></v-textarea>

           <v-textarea
             background-color="transparent"
             solo
             v-model="formanimal.story"
             label="Védenc története"
           ></v-textarea>

           <div class="viewImage" v-if="adminmethod==='update'">
             <v-img max-width=150 :src="animal.thumbnailImage"></v-img>
           </div>
           <v-file-input
           class="mb-5"
            show-size
            :label="adminmethod==='new' ? 'Listakép' : 'Listakép cseréje'"
            hint="Max 30kb"
            persistent-hint
            v-model="formanimal.thumbnailImage"
            :rules="[rules.thumbnail,]"
            >
           </v-file-input>



           <div class="viewImage" v-if="adminmethod==='update'">
             <v-img max-width=150 :src="animal.mainImage"></v-img>
           </div>
           <v-file-input
           class="mb-5"
            show-size
            :label="adminmethod==='new' ? 'Adatlap-főkép' : 'Adatlap-főkép cseréje'"
            v-model="formanimal.mainImage"
            hint="Max 200kb"
            persistent-hint
            :rules="[rules.image,]"
            >
           </v-file-input>


           <div class="viewImage" v-if="adminmethod==='update' && animal.image2">
             <v-img max-width=150 :src="animal.image2"></v-img>
           </div>
           <v-file-input
           class="mb-5"
            show-size
            label="2.nagykép (opcionális)"
            v-model="formanimal.image2"
            hint="Max 200kb"
            persistent-hint
            :rules="[rules.image,]"
            >
           </v-file-input>


           <div class="viewImage" v-if=" adminmethod==='update' && animal.image3">
             <v-img max-width=150 :src="animal.image3"></v-img>
           </div>
           <v-file-input
           class="mb-5"
            show-size
            label="3.nagykép (opcionális)"
            v-model="formanimal.image3"
            hint="Max 200kb"
            persistent-hint
            :rules="[rules.image,]"
            >
           </v-file-input>

           <v-btn
            v-if="adminmethod==='new'"
             color="success"
             class="mr-4 mt-5"
             @click="submitData"
           >
             Új védenc létrehozása
           </v-btn>

           <v-btn
              v-if="adminmethod==='update'"
              color="success"
              class="mr-4 mt-5"
              @click="updateData"
           >
             Módosítom!
           </v-btn>
         </v-form>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import axios from 'axios';
import {colorcodes} from '@/components/colorcodes';

let colorcodelistinfo = ""

for (const [color, desc] of Object.entries(colorcodes)) {
  colorcodelistinfo += `${color} - ${desc}` + "; <br/>"
}

export default {
  props: ['adminmethod', 'animal'],
  data(){
    return{
      formanimal:{
        shelterID: this.adminmethod==='update' ? this.animal.shelterID : '',
        name: this.adminmethod==='update' ? this.animal.name : '',
        species: this.adminmethod==='update' ? this.animal.species : 'eb',
        gender: this.adminmethod==='update' ? this.animal.gender : '',
        age: this.adminmethod==='update' ? this.animal.age : '',

        breed: this.adminmethod==='update' && this.animal.breed ? this.animal.breed : '',
        size: this.adminmethod==='update' && this.animal.size ? this.animal.size : '',
        date_of_arrival: this.adminmethod==='update' ? this.animal.date_of_arrival : '',
        date_of_adoption:this.adminmethod==='update' && this.animal.date_of_adoption ? this.animal.date_of_adoption : '',


        colorcode: this.adminmethod==='update' && this.animal.colorcode ? this.animal.colorcode : '',
        puppy: this.adminmethod==='update' ? this.animal.puppy : false,
        adoptable: this.adminmethod==='update' ? this.animal.adoptable : false,

        sociallink: this.adminmethod==='update' && this.animal.social_link_string ? this.animal.social_link_string : '',
        documentlink: this.adminmethod==='update' && this.animal.documents_link_string ? this.animal.documents_link_string : '',
        other: this.adminmethod==='update' && this.animal.other ? this.animal.other : '',
        story: this.adminmethod==='update' && this.animal.story ? this.animal.story : '',

        thumbnailImage:  null,
        mainImage: null,
        image2: null,
        image3: null,
      },
      formerrors: false,
      genderItems: ['ivaros kan', 'ivaros szuka', 'ivartalanított szuka', 'ivartalanított kan'],
      colorCodeItems: ['green', 'yellow', 'blue', 'red', 'pink', 'black'],
      speciesItems:['eb', 'macska', 'ló'],
      colorcodelistinfo,
      datepicker1: false,
      datepicker2: false,
      rules: {
        required: value => !!value || 'Kötelező.',
        thumbnail: value =>  {
          if (value !== null) {
            return value.size < 30000 || 'Thumbnail image should be less than 30kb!'
          }
          return true;
        },
        image: value =>  {
          if (value !== null) {
            return value.size < 200000 || 'Image should be less than 200kb!'
          }
          return true;
        },
      }
    }
  },
  methods:{
    createFormData(){
      if (this.$refs.form.validate()) {
        let formdata = new FormData();
        formdata.append('shelterID', this.formanimal.shelterID)
        formdata.append('age', this.formanimal.age)
        formdata.append('name', this.formanimal.name)
        formdata.append('species', this.formanimal.species)
        formdata.append('gender', this.formanimal.gender)

        formdata.append('breed', this.formanimal.breed)
        formdata.append('size', this.formanimal.size)

        formdata.append('date_of_arrival', this.formanimal.date_of_arrival)

        if (this.formanimal.date_of_adoption === null) {
          formdata.append('date_of_adoption', '')
        }else{
          formdata.append('date_of_adoption', this.formanimal.date_of_adoption)
        }

        formdata.append('puppy', this.formanimal.puppy)
        formdata.append('colorcode', this.formanimal.colorcode)
        formdata.append('adoptable', this.formanimal.adoptable)
        formdata.append('other', this.formanimal.other)
        formdata.append('story', this.formanimal.story)
        formdata.append('social_link_string', this.formanimal.sociallink)
        formdata.append('documents_link_string', this.formanimal.documentlink)

        if (this.formanimal.thumbnailImage) {
          formdata.append('thumbnailImage', this.formanimal.thumbnailImage)
        }
        if (this.formanimal.mainImage) {
          formdata.append('mainImage',this.formanimal.mainImage)
        }

        if (this.formanimal.image2) {
          formdata.append('image2', this.formanimal.image2)
        }
        if (this.formanimal.image3) {
          formdata.append('image3', this.formanimal.image3)
        }
        return formdata;
      }
      else{
        return
      }
    },
    submitData(){
      const formdata = this.createFormData();
      if (typeof formdata != "undefined") {
        axios.post('/api/update-animals/', formdata,
          {headers:{
              'Authorization': `Token ${this.token}`,
              'Content-Type': 'multipart/form-data'
            },
          })
        .then(res=>{
          this.$store.dispatch('setAnimals');
          this.$router.push('/')
        })
        .catch(err=>{
          this.formerrors = true;
        })
      }
      else{
      this.formerrors = true;
      }
    },
    updateData(){
      const formdata = this.createFormData();
      if (typeof formdata != "undefined") {

        axios.patch(`/api/update-animals/${this.animal.id}/`, formdata,
          {headers:{
              'Authorization': `Token ${this.token}`,
              'Content-Type': 'multipart/form-data'
            },
          })
        .then(res=>{
          this.$store.dispatch('setAnimals');
          this.$router.push('/')
        })
        .catch(err=>{
          this.formerrors = true;
        })
      }
      else{
      this.formerrors = true;
      }
    }
  },
  computed:{
    token(){
      return this.$store.getters.token;
    },
    allAnimals(){
      return this.$store.getters.allAnimals;
    }
  },
  created(){
    window.scrollTo(0,0);
  }
}
</script>

<style lang="scss">
.animalform .viewImage{
  margin-left: 5%;
  margin-top: 25px;
}

.demoflashing{
  animation-duration: 5s;
}

.v-list.v-sheet.theme--light{
  background-color: $forminputbg;
}

.v-autocomplete__content.v-menu__content {
  border-radius: 8px !important;
}

</style>
